import { CELL_WIDTH, LABEL_MARGIN } from "./constants"

export function getCells(parent) {
  return Array.from(parent.querySelectorAll("g.elevation")).map((elev) =>
    Array.from(elev.querySelectorAll("g.group-cell")),
  )
}

/**
 * Sets (mutates) the element transform attribute to the new one based on position
 * @param {SVGGElement} el - assumes it is .group-cell element
 * @param {Number} position - index of the element among siblings
 * @returns {void}
 */
function setCellPosition(el, position) {
  const [, y] = el.getAttribute("transform").match(/translate\([0-9.]+,? ([0-9.]+)\)/)

  const newX = (LABEL_MARGIN + position * CELL_WIDTH).toFixed(2)

  el.setAttribute("transform", `translate(${newX} ${y})`)
}

/**
 * An interface helps to manipulate .group-cell elements within an svg
 * @param {SVGSVGElement} svg
 * @returns {Object} api
 */
function Cells(svg) {
  let cells = getCells(svg)

  const api = {
    get cells() {
      return cells
    },
    /* eslint-disable no-loop-func */
    /**
     * Deletes a particular amount of elements and adds new cells to the start point.
     * Updates cells positionating.
     * @param {Number} start - an index
     * @param {Number} deleteCount - amount of cells to delete
     * @param {Array.<SVGGElement>} items - a list of new cells
     * @returns {Function} a side effect mutate function to do the splice
     */
    splice(start, deleteCount, items) {
      const changes = cells.map((row, index) => {
        const removed = row.slice(start, start + deleteCount)
        const before = row[start + deleteCount] || null
        const parent = row[0].parentNode
        const next = [...row]
        next.splice(start, deleteCount, ...items[index])
        return { before, items: items[index], next, parent, removed }
      })

      return function run() {
        changes.forEach(({ before, items: newItems, next, parent, removed }) => {
          removed.forEach((cell) => cell.remove())
          newItems.forEach((cell) => parent.insertBefore(cell, before))
          next.forEach((cell, position) => setCellPosition(cell, position))
        })

        cells = changes.map(({ next }) => next)
      }
    },
    /* eslint-enable no-loop-func */
  }

  return Object.freeze(api)
}

export default Cells
